import * as React from 'react';
import { forwardRef } from 'react';

var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const SvgBackArrow24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3900_189226)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 5C15.8659 5.00012 19 8.13408 19 12C18.9999 15.8658 15.8658 18.9999 12 19C8.1341 19 5.00015 15.8659 5 12C5 8.13401 8.13401 5 12 5ZM13.5195 8.14648C13.3243 7.9513 13.0077 7.95125 12.8125 8.14648L9.3125 11.6465C9.11762 11.8417 9.11743 12.1584 9.3125 12.3535L12.8125 15.8535C13.0076 16.0487 13.3242 16.0484 13.5195 15.8535C13.7148 15.6583 13.7148 15.3417 13.5195 15.1465L10.373 12L13.5195 8.85352C13.7148 8.65825 13.7148 8.34175 13.5195 8.14648Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3900_189226"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBackArrow24);

export { ForwardRef as ReactComponent };
//# sourceMappingURL=BackArrow24.svg.js.map
